<div class="container">


    <div *ngIf="listingStatus != null">
        {{listingStatus}}
    </div>
    <div *ngIf="isListed() && listingStatus == null">
        <a target="_blank" [href]="'https://ebay.com.au/itm/'+item.ebay.ItemID">https://ebay.com.au/itm/{{item.ebay.ItemID}}</a>
    </div>
    <div *ngIf="!isListed() && listingStatus == null">
        Unlisted
    </div>


    <div *ngIf="!isLoading">

        <div class="error" *ngIf="listingStatus == 'Listing Error'">
            <div *ngFor="let error of critical">{{error}}</div>
        </div>

        <div class="ebay-actions">
            <button *ngIf="!isListed()" mat-raised-button (click)="listItem()">List on ebay</button>

            <!-- <a mat-raised-button target="_blank" [href]="'https://www.ebay.com.au/lstng?mode=ReviseItem&itemId='+item.ebay.ItemID+'&mode=ReviseItem'">Revise Listing</a> -->
            <!-- <button *ngIf="item.ebay.ItemID != 0" mat-raised-button (click)="reviseFixedPriceItem()">Revise Listing</button> -->
            <button *ngIf="isListed()" mat-raised-button (click)="removeItem()">Remove Listing</button>
            <button *ngIf="isListed()" mat-raised-button (click)="checkListing()">Check Listing</button>
            
            <button *ngIf="!isListed()" mat-raised-button (click)="reloadDynamic()">Fill Defaults</button>
        </div>

        <div class="images">
            <div class="image hasRequiredImage" *ngFor="let media of item.ebayImages; let i=index">
                <div class="requiredImage" [ngStyle]="{'background-image': getImageUrl(media)}"></div>
                <div class="row">
                    <button *ngIf="!isListed()" (click)="editImage(media, i)" mat-button>Edit</button>
                    <button *ngIf="!isListed()" (click)="removeImage(i)" mat-button>Remove</button>
                </div>
                <div *ngIf="!isListed()" class="row">
                    <button (click)="shiftImageLeft(i)" mat-button><mat-icon>chevron_left</mat-icon></button>
                    <button (click)="shiftImageRight(i)" mat-button><mat-icon>chevron_right</mat-icon></button>
                </div>
            </div>
        </div>

        <div class="feature-desktop">
            <div class="label">
                Ebay Title
            </div>
            <div class="value">
                <input [disabled]="isListed()" tabindex="1" [(ngModel)]="item.ebay.Title" placeholder="Text" matInput (blur)="save()" aria-label="field-text">
            </div>
        </div>

        <div class="feature-desktop">
            <div class="label">
                Price
            </div>
            <div class="value">
                <ap-money [inDollars]="true" [(amount)]="item.ebay.StartPrice" matInput (amountChange)="save()" aria-label="field-text"></ap-money>
                <!-- <input [disabled]="isListed()" tabindex="1" [(ngModel)]="item.ebay.StartPrice" placeholder="Text" matInput (blur)="save()" aria-label="field-text"> -->
            </div>
        </div>

        <div class="feature-desktop">
            <div class="label">
                Category
            </div>
            <div class="value">
                <input [disabled]="isListed()" tabindex="1" [(ngModel)]="item.ebay.PrimaryCategory.CategoryID" placeholder="Text" matInput (blur)="save()" aria-label="field-text">
            </div>
        </div>

        <div class="feature-desktop">
            <div class="label">
                Condition
            </div>
            <div class="text">
                <mat-select [(value)]="item.ebay.ConditionID" (selectionChange)="save()" placeholder="Condition">
                    <mat-option *ngFor="let condition of itemConditions"
                        [value]="condition.conditionId">{{condition.conditionDescription}}</mat-option>
                </mat-select>
            </div>
        </div>

        <div class="feature-desktop">
            <div class="label">
                Best Offer
            </div>
            <div class="value">
                <button *ngIf="!item.ebay.BestOfferDetails.BestOfferEnabled" mat-raised-button (click)="enableBestOffer()">Enable</button>
                <button *ngIf="item.ebay.BestOfferDetails.BestOfferEnabled" mat-raised-button (click)="disableBestOffer()">Disable</button>
            </div>
        </div>

        <div *ngIf="item.ebay.BestOfferDetails.BestOfferEnabled" class="feature-desktop">
            <div class="label">
                Best Offer Mininum
            </div>
            <div class="value">
                <ap-money [(amount)]="item.ebay.ListingDetails.MinimumBestOfferPrice" (amountChange)="bestOfferMinChange($event)" [inDollars]="true"></ap-money>
            </div>
        </div>

        <div *ngIf="item.ebay.BestOfferDetails.BestOfferEnabled" class="feature-desktop">
            <div class="label">
                Best Offer Auto Accept
            </div>
            <div class="value">
                <ap-money [max]="item.ebay.StartPrice-1" [(amount)]="item.ebay.ListingDetails.BestOfferAutoAcceptPrice" (amountChange)="bestOfferAutoAcceptChange($event)" [inDollars]="true" [noZeroValue]="true"></ap-money>
            </div>
        </div>

        <div class="feature-desktop" *ngFor="let specifics of item.ebay.ItemSpecifics.NameValueList; let i = index">
            <div class="custom-label">
                <input [disabled]="isListed()" placeholder="Label" [(ngModel)]="specifics.name" (blur)="save()" matInput aria-label="field-label">
            </div>
            <div class="text">
                <input [disabled]="isListed()" placeholder="Text" [(ngModel)]="specifics.value" (blur)="save()" matInput aria-label="field-text">
            </div>
            <div class="action">
                <button (click)="deleteFeature(i)" mat-button><mat-icon>delete</mat-icon></button>
            </div>
        </div>
        
        <div class="feature-actions">
            <button [disabled]="isListed()" (click)="addFeature()" mat-raised-button>Add Feature</button>
        </div>

        <div class="description">
            <ckeditor [disabled]="isListed()" [editor]="Editor" (blur)="descriptionOnBlur($event)" [data]="item.ebay.Description"></ckeditor>
        </div>


    </div>
